import React from 'react';
import { Col, Row } from 'reactstrap';
import SliderComponent from '../../Components/Slider/Slider';
import styles from './Works.module.scss';
import { Animated } from 'react-animated-css';

const Works = () => {
  let imgArr = [
    'Assets/kay.png',
    'Assets/kay1.jpeg',
    'Assets/kay2.png',
    'Assets/kay3.png',
    'Assets/kay.png',
    'Assets/kay1.jpeg',
    'Assets/kay2.png',
    'Assets/kay3.png',
    'Assets/kay.png',
    'Assets/kay1.jpeg',
    'Assets/kay2.png',
    'Assets/kay3.png',
  ];
  return (
    <div className={styles.main_works} id="works">
      <Row>
        <Col sm={12} md={12}>
          <div className={styles.works_head}>
            <br/>
            <h2>
              WO<span>RKS</span>
            </h2>
          </div>
        </Col>
        <Col sm={12} md={12}>
          <SliderComponent imgs={imgArr} />
        </Col>
        <Col sm={12} md={12}>
          <Animated
            isVisible={true}
            animationIn='animate__fadeInUpBig'
            animationOut='animate__fadeInUpBig'
          >
            <div className={styles.joining}>
              <div>
                <h1>
                  INTRO<span>DUCTION</span>
                </h1>
              </div>
              <div>
                <p>
                   Welcome to the world of Mutant Ape Base Club NFTs, 
                   an exciting and innovative project that combines the 
                   power of non-fungible tokens (NFTs) with a native token 
                   designed to reward and incentivize its vibrant community. 
                   In this introduction, we will explore the unique features 
                   and benefits of the Mutant Ape Base Club project and shed 
                   light on how it aims to revolutionize the NFT landscape.
                </p>
              </div>
              <div>
                <p>
                  Mutant Ape Base Club NFTs is a collection of unique digital 
                  assets represented as NFTs. Each NFT in the collection features 
                  a distinctive and eye-catching Mutant Ape character, imbued with 
                  its own special traits, attributes, and rarity. These NFTs are not 
                  only visually captivating but also hold inherent value within the community.
                </p>
              </div>
              <div>
                <p>
                  One of the key elements that sets Mutant Ape Base Club apart is its native token, 
                  which serves as the lifeblood of the project. This native token acts as a reward 
                  and incentive mechanism, fostering an engaged and active community. 
                  Token holders gain access to a plethora of exclusive benefits and opportunities, 
                  creating a truly immersive and rewarding experience.
                </p>
              </div>
              <div>
                <p>
                  The native token is distributed to community members through various mechanisms, 
                  such as participating in community events, contributing to the project's growth, 
                  or holding and staking Mutant Ape NFTs. This token economy encourages participation, 
                  collaboration, and long-term commitment, as token holders can unlock exclusive content, 
                  early access to new releases, and even governance rights within the Mutant Ape Base Club ecosystem.

                </p>
              </div><br/>
              <div>
              <a href='https://xyv.gitbook.io/mutantapebaseclub/governance-structure'>
                <button>
                  <span>DOCUMENTATION</span>
                </button>
                </a>
              </div>
            </div>
          </Animated>
        </Col>
      </Row>
    </div>
  );
};

export default Works;
